import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-center items-center spinner" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("div", {
      style: {"border-top-color":"transparent"},
      class: "w-20 h-20 border-4 border-blue-400 border-solid rounded-full animate-spin"
    }, null, -1),
    _createElementVNode("div", { class: "opacity-25 fixed inset-0 z-40 bg-black" }, null, -1)
  ])))
}